module.exports = __webpack_public_path__ + "static/img/page.0471f467.svg";